import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;
`;

export const LinkWrapper = styled.div`
  text-align: left;
  padding-top: 8px;
`;
